<!-- eslint-disable vue/multiline-html-element-content-newline -->
<!-- eslint-disable vue/valid-template-root -->
<!-- eslint-disable eol-last -->
<template>
  <transition name="drawer">
    <div v-if="show" class="drawer-overlay" @click="closeModal">
      <div class="drawer-panel" @click.stop>
        <n-loader :loading="$var('load')" />

        <!-- Drawer Header -->
        <div class="drawer__header">
          <div class="drawer__title-wrap">
            <h2 class="drawer__title">Формирование АВР</h2>
            <p class="drawer__subtitle">Выберите период для создания актов</p>
          </div>
          <button class="drawer__close-btn" @click="closeModal">
            <img :src="closeIcon" alt="close icon">
          </button>
        </div>

        <!-- Drawer Body -->
        <div class="drawer__body">
          <!-- Step indicator -->
          <div class="drawer__steps">
            <div class="step" :class="{ active: true, completed: dateRange !== null }">
              <div class="step__number">1</div>
              <div class="step__info">
                <span class="step__label">Выбор периода</span>
                <span class="step__desc">Укажите даты для АВР</span>
              </div>
            </div>
            <div class="step__line" :class="{ active: dateRange !== null }"></div>
            <div class="step" :class="{ active: dateRange !== null }">
              <div class="step__number">2</div>
              <div class="step__info">
                <span class="step__label">Подтверждение</span>
                <span class="step__desc">Запуск формирования</span>
              </div>
            </div>
          </div>

          <!-- Calendar Section -->
          <div class="drawer__section">
            <div class="section__header">
              <span class="section__icon">📅</span>
              <span class="section__title">Доступный период</span>
            </div>

            <div v-if="hasDate" class="section__empty">
              <p>Нет доступных дат для формирования АВР</p>
            </div>

            <div v-else class="section__content">
              <div class="date-range-info">
                <div class="date-range-item">
                  <span class="date-range-label">С</span>
                  <span class="date-range-value">{{ formatDisplayDate(allowedDates.startDate) }}</span>
                </div>
                <div class="date-range-divider">→</div>
                <div class="date-range-item">
                  <span class="date-range-label">По</span>
                  <span class="date-range-value">{{ formatDisplayDate(allowedDates.endDate) }}</span>
                </div>
              </div>

              <c-calendare
                v-model="dateRange"
                range
                format="DD.MM.YYYY"
                :disabled-date="disableOutsideRange"
                :disabled="hasDate"
                class="drawer__calendar"
              ></c-calendare>
            </div>
          </div>

          <!-- Selected Period Preview -->
          <div v-if="dateRange && dateRange.length === 2" class="drawer__section drawer__preview">
            <div class="section__header">
              <span class="section__icon">✓</span>
              <span class="section__title">Выбранный период</span>
            </div>
            <div class="preview__content">
              <div class="preview__dates">
                <span class="preview__date">{{ formatDate(dateRange[0]) }}</span>
                <span class="preview__separator">—</span>
                <span class="preview__date">{{ formatDate(dateRange[1]) }}</span>
              </div>
              <p class="preview__hint">АВР будет сформирован за указанный период</p>
            </div>
          </div>
        </div>

        <!-- Drawer Footer -->
        <div class="drawer__footer">
          <button class="drawer__btn drawer__btn--secondary" @click="closeModal">
            Отмена
          </button>
          <button
            class="drawer__btn drawer__btn--primary"
            :disabled="dateRange === null"
            @click="createAcw"
          >
            <span class="btn__icon">+</span>
            Сформировать АВР
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import closeIcon from 'assets/add-card-icon.svg'
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/index.css';

export default {
  props: {
    show: {
      type: Boolean,
    },
    companyId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: () => ({
    closeIcon,
    dateRange: null,
    allowedDates: {},
  }),
  computed: {
    hasDate() {
      return Object.keys(this.allowedDates).length === 0
    }
  },
  watch: {
    show(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
        this.getAvalabelDate();
      } else {
        document.body.style.overflow = '';
      }
    },
    companyId: {
      immediate: true,
      handler(newVal) {
        if (newVal > 0) {
          this.getAvalabelDate();
        }
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$emit('close')
      this.dateRange = null;
      this.allowedDates = {};
    },
    disableOutsideRange(date) {
      const [ startYear, startMonth, startDay ] = this.allowedDates.startDate.split('-').map(Number);
      const [ endYear, endMonth, endDay ] = this.allowedDates.endDate.split('-').map(Number);
      const startDate = new Date(startYear, startMonth - 1, startDay);
      const endDate = new Date(endYear, endMonth - 1, endDay);
      const currentDate = this.normalizeDate(date);
      return currentDate < startDate || currentDate > endDate;
    },
    normalizeDate(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${day}.${month}.${year}`;
    },
    formatDisplayDate(dateStr) {
      if (!dateStr) return '';
      const [year, month, day] = dateStr.split('-');
      return `${day}.${month}.${year}`;
    },

    getAvalabelDate() {
      this.$var('load', true)
      $api.document.getAvalabelRange(this.companyId)
        .then((response) => {
          this.allowedDates = response.data.content;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => this.$var('load', false))
    },
    createAcw() {
      this.$var('load', true)

      if (this.dateRange && this.dateRange.length === 2) {
        const payload = {
          startDate: this.formatDateForApi(this.dateRange[0]),
          endDate: this.formatDateForApi(this.dateRange[1]),
          companyId: this.companyId
        };

        $api.document.createAcw(payload)
          .then((response) => {
            if (response.status === 201) {
              this.closeModal();
              $app.ui.notify('Вы запустили процесс формирования АВР', 'success')
            }
          })
          .catch((error) => {
            $app.ui.notify('Не удалось создать АВР, обновите страницу', 'danger')
          })
          .finally(() => this.$var('load', false))
      }
    },
    formatDateForApi(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style scoped lang="scss" src="./modal-create-acw.scss"></style>
<style lang="scss" src="./datepicker.scss"></style>
